import { createSelector } from 'reselect';

const macData = state => state.macData.data;

export const macDataSelector = createSelector(
    macData,
    data => data
);

export const macWords169Selector = createSelector(
    macData,
    data => data.dispArraysSecond
);

export const macWords43Selector = createSelector(
    macData,
    data => data.dispArrays
);

export const macDataTitleSelector = createSelector(
    macData,
    data => data.title
);

export const macDataOptionsSelector = createSelector(
    macData,
    data => data.options
);

export const macLoadingDownloadLinkStateSelector = createSelector(
    state => state.macData,
    data => data.loadingDownloadLink
);

export const macTableDataSelector = createSelector(
    state => state.macData,
    data => data.dataTable.data
);

export const macMenusLoadingSelector = createSelector(
    state => state.macData,
    data => data.loadingMenus
);
